/* Free gift: adds ONE gift variant to the cart when the cart goes above the set amount,
   removes it again when the cart drops below. Settings: Theme settings > Free gift (prepaid).
   - the gift line itself never counts towards the amount
   - if the customer removes the gift on purpose, it is not forced back in until the cart drops below the amount
   - works for the cart drawer and the cart page, no matter how the product was added to the cart
   The gift is for PREPAID orders only: the gift line carries a visible "Offer" property so it shows on the order. */
(function () {
  var el = document.getElementById('nv-fg-config');
  if (!el || window.__nvFg) return;
  window.__nvFg = true;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  if (!cfg || !cfg.amount || !cfg.variant) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);   // our own calls use this one, so they never trigger a re-check
  var busy = false, again = false, timer = null;

  function ss(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v);
    } catch (e) {}
    return null;
  }
  function post(url, body) {
    return nativeFetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  // redraw cart UI without opening the drawer
  function refreshUI() {
    if (document.querySelector('cart-items') && !document.querySelector('cart-drawer.active')) {
      window.location.reload();                       // cart page
      return Promise.resolve();
    }
    return nativeFetch(root + '?sections=cart-drawer,cart-icon-bubble&_=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && data['cart-drawer']) {
          var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          var src = doc.querySelector('#CartDrawer'), dst = drawer.querySelector('#CartDrawer');
          if (src && dst) dst.innerHTML = src.innerHTML;
          var cd = doc.querySelector('cart-drawer');
          if (cd) drawer.classList.toggle('is-empty', cd.classList.contains('is-empty'));
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data['cart-icon-bubble']) {
          var d2 = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
          var s2 = d2.querySelector('.shopify-section');
          if (s2) bubble.innerHTML = s2.innerHTML;
        }
      })
      .catch(function () {});
  }

  function run() {
    if (busy) { again = true; return; }
    busy = true;
    nativeFetch(root + 'cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gift = null, eligible = cart.total_price, others = 0;
        cart.items.forEach(function (it) {
          if (Number(it.variant_id) === cfg.variant) { gift = it; eligible -= it.final_line_price; }
          else others += 1;
        });
        var ok = others > 0 && eligible >= cfg.amount;

        if (ok) {
          if (!gift) {
            if (ss('nv_fg_had') === '1') { ss('nv_fg_off', '1'); return null; }       // customer removed it: respect that
            if (ss('nv_fg_off') === '1' || ss('nv_fg_fail') === '1') return null;
            return post('cart/add.js', { items: [{ id: cfg.variant, quantity: 1, properties: { Offer: 'Free gift - prepaid orders only' } }] })
              .then(function (r) {
                if (!r.ok) { ss('nv_fg_fail', '1'); try { console.warn('Free gift could not be added (check the variant ID and that it is available).'); } catch (e) {} return null; }
                ss('nv_fg_had', '1');
                return true;
              });
          }
          ss('nv_fg_had', '1');
          if (gift.quantity !== 1) return post('cart/change.js', { id: gift.key, quantity: 1 }).then(function () { return true; });
          return null;
        }
        // below the amount (or nothing else left in the cart): no gift, and the opt-out starts fresh
        ss('nv_fg_had', null); ss('nv_fg_off', null); ss('nv_fg_fail', null);
        if (gift) return post('cart/change.js', { id: gift.key, quantity: 0 }).then(function () { return true; });
        return null;
      })
      .then(function (changed) { return changed ? refreshUI() : null; })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; schedule(); }
      });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 300); }

  // every cart change made by the theme / apps goes through fetch: check again after it
  var theirFetch = window.fetch;
  window.fetch = function (input) {
    var p = theirFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) p.then(schedule, function () {});
    } catch (e) {}
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
})();
